import React, { useState, ReactNode, useCallback, useEffect, CSSProperties } from 'react';
import TopBar from './Topbar';
import Sidebar from './Sidebar'; // Adjust the import path as necessary
import { useDispatch, useSelector } from 'react-redux';
import { useWebSocket } from '../useWebSocket';
import { setNotificationOn, setNotificationType, setNotificationTitle, setNotificationMessage, setNotificationId, setNotificationOff, addNotification, showNextNotification, markNotificationAsRead, addNotifications, markRobotNotificationAsRead, markNotificationAsReadByID } from '../../store/notification/notificationSlice';
import Notification from '../../routes/dashboard/components/Notification';
import { useRef } from 'react';
import axios from 'axios';
import { JobData, JobDetails2, NotificationType, RobotData3, RobotStatus2 } from '../../store/types';
import { JobEnums } from '../../utils/enums/JobEnums';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import dayjs from 'dayjs';
import { getJobLogs } from '../../lib/api/job';
import { getRobotStatus } from '../../lib/api/robot';
import { customLog, isInPast, stopNotificationAudio } from '../../utils/utils';
import { dismissFireAlarm, fireAlarmWebsocketURL, showFireAlarm, useDismissAlarm, useFireAlarm, useSystemEvents } from '../../hooks/system_event';
import { setFireAlarmOn, setModalClose, triggerFire } from '../../store/fire/fireTriggerSlice';
import { SystemEventType } from '../../hooks/system_event/index.type';
import { AUDIO_SOURCE, AUDIO_TYPE } from '../../types/audio';
import { customAxios } from '../../lib/axios';
import { useRobots } from '../../hooks/robot';
import { DEFAULT_ROBOT_MODEL, NEW_ROBOT_HERE_AUDIO_ID, NOTIFICATION_AUDIO_ID, RobotModel } from '../../utils/const';
import { getRobotImage } from '../../routes/dashboard/mock-robots';
import { useFireAlarmContext } from '../../context/FireAlarmContext';
import { useLocation } from 'react-router-dom';
import { useMe } from '../../hooks/user';
import { current } from '@reduxjs/toolkit';
import { CLEANING_NOTIFICATION_TYPE } from '../Notification';
import { useAuth } from '../../context/AuthContext';
import elevator from '../../assets/elevator.png';

interface MainLayoutProps {
  noTopBar?: boolean;
  children: ReactNode;
}
interface JobHistory {
  [order_number: string]: JobDetails2[];
}

interface NotificationDetails {
  id: number;
  title: string;
  description: string;
  created_timestamp: number;
  notification_type: string;
}

interface notificationHistory {
  id: number;
  meta: string;
  notification_details: notificationDetails;
  read: boolean;
  read_timestamp: number;
  type: string;
  user: string;
}

interface notificationDetails {
  created_timestamp: number;
  description: string;
  id: number;
  notification_type: string;
  title: string;
}

let isCanPlaySound = false;
const swiftHereSenderStatuses = ['arrived_at_pickup']
const swiftHereRecipientStatuses = ['arrived_at_delivering']

const MainLayout: React.FC<MainLayoutProps> = ({ noTopBar, children }) => {
  const dispatch = useDispatch();
  // const profile = localStorage.getItem('profile');
  const { profile, accessToken } = useAuth()
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);
  const audioSrc = require('../../assets/notificationSound.mp3'); // Make sure the path is correct
  const audioRef = useRef<HTMLAudioElement>(null);
  const [orderNumber, setOrderNumber] = useState<string>('');
  const [jobID, setJobID] = useState<number>(0);
  const [jobDetails, setJobDetails] = useState<JobHistory>({});
  const [jobs, setJobs] = useState<JobData>({});
  const [notificationHistory, setNotificationHistory] = useState<notificationHistory[]>([]);
  const [previousJobStatus, setPreviousJobStatus] = useState<{ [order_number: string]: string }>({});
  const [robots, setRobots] = useState<RobotData3>({});
  const [previousRobotStatus, setPreviousRobotStatus] = useState<RobotData3>({});
  // const currentNotificationImageRef = useRef<string | null>(null);
  const [imageUrl, setImageUrl] = useState('');
  const location = useLocation();

  const newRobotHereAudioRef = useRef<HTMLAudioElement | null>(null);

  const { data: userData } = useMe();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const snackbarRef = useRef<string[]>([]);
  const snackbarIds = snackbarRef.current;
  const addSnackbarId = (key: string) => {
    if (!snackbarRef.current.includes(key)) {
      snackbarRef.current.push(key);
    }
  };
  const removeSnackbarIds = (key: string) => {
    snackbarRef.current = snackbarRef.current.filter((id) => id !== key);
  };

  const parsedProfile = profile ? profile : null;
  const isNotificationOn = useSelector((state: any) => state.notification.isNotificationOn);
  const notificationID = useSelector((state: any) => state.notification.notification_id);

  const handleCriticalNotification = (message: any, audioType = AUDIO_TYPE.DEFAULT) => {
    dispatch(setNotificationType("Job Update"));
    dispatch(addNotification(message));
    playSound(audioType);
  };

  const notificationQueue = useSelector((state: any) => state.notification.notificationsQueue);

  const handleSameOrderNumber = (orderNumber: string, exception?: string, autoDismiss = false) => {
    if (!notificationQueue || notificationQueue.length === 0) {
      return
    }

    notificationQueue.map((item: notificationHistory) => {
      const currentOrderNumber = JSON.parse(item.meta)?.order_number

      if (currentOrderNumber && currentOrderNumber === orderNumber && (!exception || item.id.toString() !== exception)) {
        if (autoDismiss) {
          dispatch(showNextNotification());
        }
        sendNotificationReadMessage({
          type: "receive_read",
          notification_id: item.id,
        });
      }
    })
  }

  // Utility function to handle non-critical notifications
  const handleNonCriticalNotification = (message: any) => {
    if (snackbarIds.includes(message.id.toString())) {
      // If the snackbar is already displayed, we can choose to ignore or update it
      customLog("Snackbar already exists for this notification:", message.id);
      return;
    }
    addSnackbarId(message.id.toString());
    enqueueSnackbar(message.notification_details.description, {
      key: message.id,
      variant: 'info',
      action: (key) => (
        <Button onClick={() => handleCloseSnackbar(key, message.id)}>Dismiss</Button>
      ),
      persist: false,
      preventDuplicate: true,
      style: { backgroundColor: '#EDFAFF', color: '#000', fontFamily: "Poppins" },
      autoHideDuration: 5000,
      onClose: (event, reason, key) => {
        // Only call handleCloseSnackbar if the reason is 'timeout' or 'clickaway'
        if (reason === 'timeout') {
          customLog("Dismissed due to timeout", key);
          handleCloseSnackbar(key, message.id);
        }
      },
    });
  };

  const handleCloseSnackbar = (key: any, message_id: number) => {
    removeSnackbarIds(message_id.toString());
    removeSnackbarIds(key);
    closeSnackbar(key);
    sendNotificationReadMessage({
      type: "receive_read",
      notification_id: message_id,
    });
  }

  const handleNotification = useCallback(async (message: any) => {
    const isUserMessage = parsedProfile && parsedProfile?.uuid === message.user;

    // customLog("lift notification:", message, "isUserMessage:", isUserMessage);

    if (message.type === CLEANING_NOTIFICATION_TYPE) {
      if (message.read) {
        // remove notification from queue
        customLog("Marking notification as read", orderNumber, message);
        dispatch(markNotificationAsReadByID({ notificationId: message.id }));
        return
      }
      const title = message.notification_details?.title
      const isCompleted = title.toLowerCase()?.includes("completed")

      const newMessageBody = {
        ...message,
        notification_details: {
          ...message.notification_details,
          description: message.notification_details.body || message.notification_details.description
        }
      }

      if (isCompleted) {
        handleCriticalNotification(newMessageBody, AUDIO_TYPE.DEFAULT);
        return
      }
      handleNonCriticalNotification(newMessageBody);
      sendNotificationReadMessage({
        type: "receive_read",
        notification_id: message.id,
      });
      return
    }
    if (message.notification_details.notification_type === "job_notification") {
      // Differentiate between sender and recipient notifications
      const orderNumber = JSON.parse(message.meta).order_number;
      customLog("check message id", message.id);
      if (message.read) {
        // remove notification from queue
        customLog("Marking notification as read", orderNumber, message);
        dispatch(markNotificationAsRead({ orderNo: orderNumber, notificationID: message.id }));
      } else {
        // job is not read, handle
        if (message.type === "sender_notification" && isUserMessage) {
          // Handling Arrive at pickup
          const metaObj = JSON.parse(message.meta)
          const jobStatus = metaObj?.job_status || '-'
          const orderNumber = metaObj?.order_number || metaObj || '-'
          const swiftHereCondition = swiftHereSenderStatuses.includes(jobStatus)

          if (['delivering'].includes(jobStatus)) {
            handleSameOrderNumber(orderNumber, undefined, true)
            if (currentNotification) {
              const metaObj = JSON.parse(message.meta)
              const currentOrderNumber = metaObj?.order_number || ''
              if (currentOrderNumber === orderNumber) {
                dispatch(showNextNotification());
              }
            } else {
              dispatch(showNextNotification());
            }
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: message.id,
            });

          } else if (message.notification_details.title?.toLowerCase().includes("robot arrived at pickup point") || swiftHereCondition) {
            customLog("Critical notification sender", message.notification_details.description);
            const isPast = isInPast(dayjs.unix(message.notification_details.created_timestamp))

            const isOngoingJobAndNotPast = !isPast ? await checkIsOnGoingJob(orderNumber) : false;
            if (isOngoingJobAndNotPast) {
              handleSameOrderNumber(orderNumber, message.id)
              handleCriticalNotification(message, swiftHereCondition ? AUDIO_TYPE.SWIFT_HERE : AUDIO_TYPE.DEFAULT);
            } else {
              // Set as Read
              sendNotificationReadMessage({
                type: "receive_read",
                notification_id: message.id,
              });
            }
          } else {
            customLog("Non-critical notification sender ", message.notification_details.title);
            handleNonCriticalNotification(message);
          }
        } else if (message.type === "recipient_notification" && isUserMessage) {
          // Handling Arrive at delivering
          const metaObj = JSON.parse(message.meta)
          const jobStatus = metaObj?.job_status || '-'
          const orderNumber = metaObj?.order_number || metaObj || '-'
          const swiftHereCondition = swiftHereRecipientStatuses.includes(jobStatus)

          if ([JobEnums.ITEM_DELIVERED, JobEnums.DELIVERING].includes(jobStatus)) {
            handleSameOrderNumber(orderNumber, undefined, true)
            if (currentNotification) {
              const metaObj = JSON.parse(message.meta)
              const currentOrderNumber = metaObj?.order_number || ''

              if (currentOrderNumber === orderNumber) {
                dispatch(showNextNotification());
              }
            } else {
              dispatch(showNextNotification());
            }
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: message.id,
            });

          } else if (message.notification_details.title?.toLowerCase().includes("robot arrived at delivery point") || swiftHereCondition) {
            customLog("Critical notification recipient", message.notification_details.title);
            const isPast = isInPast(dayjs.unix(message.notification_details.created_timestamp))

            const isOngoingJobAndNotPast = !isPast ? await checkIsOnGoingJob(orderNumber) : false;
            if (isOngoingJobAndNotPast) {
              handleSameOrderNumber(orderNumber, message.id)
              handleCriticalNotification(message, swiftHereCondition ? AUDIO_TYPE.SWIFT_HERE : AUDIO_TYPE.DEFAULT);
            } else {
              // Set as Read
              sendNotificationReadMessage({
                type: "receive_read",
                notification_id: message.id,
              });
            }
          } else {
            customLog("Non-critical notification recipient", message.notification_details.title);
            handleNonCriticalNotification(message);
          }
        }
      }
    } else if (message.notification_details.notification_type === "robot_notification") {
      const robot_id = JSON.parse(message.meta).robot_id;

      if (message.read) {
        dispatch(markRobotNotificationAsRead({ robot_id: robot_id, notificationID: message.id }));
      } else {
        dispatch(setNotificationType("Robot Update"));
        dispatch(addNotification(message));
      }
    } else {
      const orderNumber = JSON.parse(message.meta).order_number;
      if (message.read) {
        dispatch(markNotificationAsRead(orderNumber));
      } else {
        dispatch(setNotificationType("Failed"));
        dispatch(addNotification(message));
      }
    }
  }, []);

  const checkIsOnGoingJob = async (orderNumber: string) => {
    try {
      const getLogs = await getJobLogs(orderNumber)
      const logs = getLogs.data;
      // Find Log data which the status is considered as done
      const findedItemDelivered = logs.find((item: JobDetails2) => [
        // List of Done Job Status
        JobEnums.ITEM_DELIVERED,
        JobEnums.PICKED_UP_FAILED,
        JobEnums.DELIVERY_FAILED,
        JobEnums.RETURN_FAILED,
        JobEnums.CANCELLED,
        JobEnums.ARRIVED_AT_DESTINATION
      ].includes(item.job_status))

      // Consider as isOngoingJob when there is no logs or theres no item_delivered in the status
      const isOngoingJob = !logs || logs.length === 0 || !findedItemDelivered;
      return isOngoingJob
    } catch (error) {
      return false
    }
  }
  const filterIsOnGoingOrEstopJob = async (notifications: notificationHistory[]) => {
    const results: notificationHistory[] = []
    for (const data of notifications) {
      try {
        const isEstop = data.notification_details.title.toLowerCase().includes("e-stop");
        if (isEstop) {
          const robotId = JSON.parse(data.meta).robot_id;

          // Check is Robot id still e-stop
          const robotStatuses: RobotStatus2[] = await getRobotStatus();
          const findRobot = robotStatuses.find((item) => item.robot_id === robotId);

          // Is still e-stop then show the notif
          if (findRobot && findRobot.robot_state === 'estop') {
            results.push(data)
          }
        } else {
          // Check Job Log based on order_number
          const orderNumber = JSON.parse(data.meta).order_number;
          const isPast = isInPast(dayjs.unix(data.notification_details.created_timestamp))
          const isOngoingJobAndNotPast = !isPast ? await checkIsOnGoingJob(orderNumber) : false;

          // If isOnGoingJob then show as critical
          if (isOngoingJobAndNotPast) {
            results.push(data)
          } else {
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: data.id,
            });
          }
        }

        // When Something went wrong then do nothing
      } catch (error) { }
    };
    return results
  }

  const queryNotificationHistory = async (pageToLoad = 1, readStatus = false) => {
    customLog("Querying notification history", pageToLoad);
    try {
      const response = await customAxios({
        method: "GET",
        url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/notification/?page=${pageToLoad}&page_size=20&read=${readStatus}`,
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      if (response.status === 200) {

        const newNotifications = response.data.data;
        setNotificationHistory((prev) => [...prev, ...newNotifications]);

        // Get the existing notification IDs from the state
        const existingNotificationIds = new Set(notificationQueue.map((n: notificationHistory) => n.id));

        // Filter out duplicates
        const uniqueNotifications = newNotifications.filter(
          (notification: notificationHistory) => !existingNotificationIds.has(notification.id)
        );
        customLog("Unique notifications", response.data.data);

        // Keep only critical notifications
        const criticalNotifications: notificationHistory[] = await filterIsOnGoingOrEstopJob(uniqueNotifications.filter(
          (notification: notificationHistory) =>
            (notification.notification_details.title.toLowerCase() === "robot arrived at pickup point" && notification.type === "sender_notification") ||
            (notification.notification_details.title.toLowerCase() === "robot arrived at delivery point" && notification.type === "recipient_notification") ||
            notification.notification_details.notification_type === "robot_notification"
        ));
        // const criticalNotifications = criticalNotificationsFiltered)
        customLog("Critical notifications", criticalNotifications);
        const unCriticalNofications = uniqueNotifications.filter((data: notificationHistory) => {
          const findId = criticalNotifications.find((item) => data.id === item.id)
          return !findId
        })

        unCriticalNofications.map((notification: notificationHistory) => {
          customLog("Marking uncritical notification as read:", notification.id);
          sendNotificationReadMessage({
            type: "receive_read",
            notification_id: notification.id,
          });
        })

        const nonCriticalNotifications = uniqueNotifications.filter(
          (notification: notificationHistory) => (
            (notification.notification_details.title.toLowerCase() !== "robot arrived at pickup point" || notification.type !== "sender_notification") &&
            (notification.notification_details.title.toLowerCase() !== "robot arrived at delivery point" || notification.type !== "recipient_notification") &&
            notification.notification_details.notification_type !== "robot_notification")
        );


        customLog("Non-critical notifications", nonCriticalNotifications);
        // Mark non-critical notifications as read immediately
        nonCriticalNotifications.forEach((notification: notificationHistory) => {
          customLog("Marking non-critical notification as read:", notification.id);
          sendNotificationReadMessage({
            type: "receive_read",
            notification_id: notification.id,
          });
        });

        customLog("existing critical notifications", criticalNotifications);
        // filter critical notifications
        // if meta data for robot is the same, take the latest notification, and read the rest, if order number is the same, take the latest notification and read the rest
        // if order number is the same, take the latest notification and read the rest

        // criticalNotifications.map ((notification: notificationHistory) => {
        //     customLog("Checking existing notification", notification);
        //     // const orderNumber = JSON.parse(notification.meta).order_number;
        //     // const robotId = JSON.parse(notification.meta).robot_id;
        //     if (notification.notification_details.notification_type === "robot_notification") {
        //       const robotId = JSON.parse(notification.meta).robot_id;
        //       const existingRobotNotification = notificationQueue.find((n: notificationHistory) => JSON.parse(n.meta).robot_id === robotId);
        //       customLog("Existing robot notification", existingRobotNotification);
        //     }
        //     else if (notification.notification_details.notification_type === "job_notification") {
        //       const orderNumber = JSON.parse(notification.meta).order_number;
        //       customLog("Checking existing job notification", orderNumber);

        //     }


        //     // if (existingNotification) {
        //     //   customLog("Marking existing notification as read:", existingNotification.id);
        //     //   sendNotificationReadMessage({
        //     //     type: "receive_read",
        //     //     notification_id: existingNotification.id,
        //     //   });
        //     // }

        // });

        const notificationsByOrderNumber: { [order_number: string]: notificationHistory[] } = {};

        criticalNotifications.forEach((notification: notificationHistory) => {
          const orderNumber = JSON.parse(notification.meta).order_number;
          if (!notificationsByOrderNumber[orderNumber]) {
            notificationsByOrderNumber[orderNumber] = [];
          }
          notificationsByOrderNumber[orderNumber].push(notification);
        });
        customLog("Notifications by order number", notificationsByOrderNumber);
        // Mark older notifications as read and keep only the latest one
        const filterNewNotifs: notificationHistory[] = []
        Object.keys(notificationsByOrderNumber).forEach((orderNumber) => {
          const notifications = notificationsByOrderNumber[orderNumber];
          notifications
            .sort((a, b) => b.notification_details.created_timestamp - a.notification_details.created_timestamp)
            .forEach((notification, index) => {
              if (index === 0) {
                filterNewNotifs.push(notification)
              } else {
                sendNotificationReadMessage({
                  type: "receive_read",
                  notification_id: notification.id,
                });
                // dispatch(markNotificationAsRead({ orderNo: orderNumber, notificationID: notification.id }));
              }
            });
        });
        // check notification by order number
        // if order number is the same, take the latest notification and read the rest
        customLog("Critical notifications", notificationsByOrderNumber);
        // Add all unique critical notifications at once
        dispatch(addNotifications(filterNewNotifs));
        customLog("Notification history", newNotifications);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [counter, setCounter] = useState(0);
  const [queried, setQueried] = useState(false);
  useEffect(() => {
    if (!queried && !!accessToken && !!profile.organisation) {
      setQueried(true);
      queryNotificationHistory();
    }
  }, [queried]);



  useEffect(() => {
    customLog("Job details from layout", jobDetails)
    customLog("Jobs from layout", jobs)
  }, [jobs, jobDetails])

  // useWebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}/notification/${parsedProfile.uuid}/`, handleNotification);
  const notificationWebSocketUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/notification/${parsedProfile?.uuid}/`;
  const sendNotificationReadMessage = useWebSocket(notificationWebSocketUrl, handleNotification);
  const currentNotification = useSelector((state: any) => state.notification.currentNotification);

  const handleMessage = useCallback((data: any) => {
    const job = data;
    customLog("Job data received:", job);

    setJobs((prevJobs) => {
      const updatedJobs = { ...prevJobs, [job.order_number]: job };

      // Retrieve the previous status from state
      const previousStatus = previousJobStatus[job.order_number];
      customLog("previousStatus:", previousStatus);
      customLog("job.job_status:", job.job_status);

      // If there's a status change or if it's the first time we're seeing this job, update previousJobStatus
      if (!previousStatus || previousStatus !== job.job_status) {
        customLog(`Updating job status from ${previousStatus} to ${job.job_status}`);

        // Update the previous job status
        setPreviousJobStatus((prevStatus) => ({
          ...prevStatus,
          [job.order_number]: job.job_status,
        }));

        // Check if the new job status means the notification should be marked as read
        if (job.job_status === JobEnums.ITEM_LOADED || job.job_status === JobEnums.ITEM_DELIVERED || job.job_status === JobEnums.DELIVERING) {
          customLog(`Marking notification for order ${job.order_number} as read due to status change. notificationQueue:`, notificationQueue);

          // Find the notification ID in the queue to send read confirmation
          const notification = notificationQueue.find((notification: any) =>
            JSON.parse(notification.meta).order_number === job.order_number
          );

          customLog("Notification to mark as read:", notification);

          dispatch(markNotificationAsRead(job.order_number));
          if (currentNotification && JSON.parse(currentNotification.meta).order_number === job.order_number) {
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: currentNotification.id,
            });
          }
          if (notification) {
            const id = notification.id;
            // Send read confirmation
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: id,
            });
          }
        }
      }

      return updatedJobs;
    });
  }, [dispatch, previousJobStatus, notificationQueue, sendNotificationReadMessage]);


  const handleRobotStatus = useCallback((data: any) => {
    const robotId = data.robot_id;
    customLog("marking notification as read 2", currentNotification);
    setRobots((prevRobots) => {
      const updatedRobots = {
        ...prevRobots,
        [robotId]: {
          robotStatus: data
        }
      };
      const previousStatus = previousRobotStatus[robotId];
      customLog("previousRobotStatus:", previousStatus);
      customLog("data.robot_status:", data.robot_state);
      if (!previousStatus || previousStatus.robotStatus?.robot_state !== data.robot_state) {
        customLog(`Updating robot status from ${previousStatus} to ${data.robot_state}`);
        // Update the previous robot status
        setPreviousRobotStatus((prevStatus) => ({
          ...prevStatus,
          [robotId]: data,
        }));
        if (data.robot_status !== "estop") {
          customLog(`Marking notification for robot ${robotId} as read due to status change. notificationQueue:`, currentNotification, notificationQueue);
          const notification = notificationQueue.find((notification: any) =>
            JSON.parse(notification.meta).robot_id === robotId
          );
          customLog("Notification to mark as read:", notification, data);
          dispatch(markRobotNotificationAsRead(robotId));
          if (currentNotification && JSON.parse(currentNotification.meta).robot_id === robotId) {
            customLog("Marking current notification as read 2:", currentNotification.id);
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: currentNotification.id,
            });
          }
          if (notification) {
            const id = notification.id;
            sendNotificationReadMessage({
              type: "receive_read",
              notification_id: id,
            });
          }
        }
      }
      return updatedRobots;
    });
  }
    , [dispatch, previousRobotStatus, notificationQueue, sendNotificationReadMessage, currentNotification]);

  const jobOverviewUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/delivery/overview/${parsedProfile?.uuid}/`;
  const robotStatus = `${process.env.REACT_APP_WEBSOCKET_URL}/robot/${parsedProfile?.organisation}/`;
  useWebSocket(jobOverviewUrl, handleMessage);
  useWebSocket(robotStatus, handleRobotStatus);

  // useWebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}/notification/${parsedProfile.uuid}/`, handleNotification);
  const closeNotification = (id: number) => {

    // dispatch(setNotificationOff());
    customLog("closing notification", id, currentNotification);

    // After 100 milisecond, show the next notification if available
    setTimeout(() => {
      dispatch(showNextNotification());

      // Stop all audio
      stopAllAudioRefs();
    }, 100);

    sendNotificationReadMessage({
      type: "receive_read",
      notification_id: id,
    });
    //set current notification to now
  };


  const { data: dataFireAlarm } = useSystemEvents({ event_type: 'fire_alarm', active: true })
  const { isFireAlarmActive, activateFireAlarm, deactivateFireAlarm } = useFireAlarmContext();
  const fireAlarms = dataFireAlarm?.data || []
  useEffect(() => {
    if (!fireAlarms || fireAlarms.length === 0) {
      return
    }

    activateFireAlarm();
    showFireAlarm(dispatch, fireAlarms[0].created_time)
  }, [fireAlarms])

  const fireAlarmURL = fireAlarmWebsocketURL(parsedProfile)

  const handleFireAlarm = useCallback((data: SystemEventType) => {
    if (data.dismissed_time === -1) {
      showFireAlarm(dispatch, data.created_time)
      activateFireAlarm();
      return
    }

    deactivateFireAlarm();
    dismissFireAlarm(dispatch)
  }, [dispatch, previousJobStatus, notificationQueue, sendNotificationReadMessage]);

  useWebSocket(fireAlarmURL, handleFireAlarm);
  const { trigger: submitDismissAlarm } = useDismissAlarm({
    onSuccess: () => {
      deactivateFireAlarm();
      dismissFireAlarm(dispatch)
    }
  })

  const onDismissAlarm = () => {
    submitDismissAlarm()
  }

  const isSGH = userData?.organisation_name.toLowerCase().includes('sgh')

  const playSound = (audioType = AUDIO_TYPE.DEFAULT) => {
    try {
      if (!isCanPlaySound) {
        return
      }
      let selectedAudioSrc = AUDIO_SOURCE.DEFAULT;
      if (audioType === AUDIO_TYPE.SWIFT_HERE || audioType === AUDIO_TYPE.ROBOT_HERE) {
        selectedAudioSrc = isSGH ? AUDIO_SOURCE.SWIFT_HERE : AUDIO_SOURCE.ROBOT_HERE;
      }
      const audio = new Audio(selectedAudioSrc);
      if (audioType === AUDIO_TYPE.SWIFT_HERE || audioType === AUDIO_TYPE.ROBOT_HERE) {
        audio.loop = true
      }


      // Stop All Other Audio if any
      stopAllAudioRefs();

      try {
        newRobotHereAudioRef.current = audio;
        newRobotHereAudioRef.current.play().then(() => {
          customLog("Audio playing successfully");
          if (newRobotHereAudioRef.current) {
            newRobotHereAudioRef.current.id = NEW_ROBOT_HERE_AUDIO_ID + '-' + Date.now().toString();
            newRobotHereAudioRef.current.classList.add(NEW_ROBOT_HERE_AUDIO_ID);
            document.body.appendChild(newRobotHereAudioRef.current);
          }
        }).catch((error) => {
          customLog("Error playing audio:", error);
        });

      } catch (error) {
        customLog("Error playing audio:", error);
      }
    } catch (error) { }
  }

  // Enable sound when user click or scroll
  const enableSound = () => {
    if (isCanPlaySound) {
      return
    }
    isCanPlaySound = true
  }

  useEffect(() => {
    document.addEventListener('click', enableSound)
    document.addEventListener('scroll', enableSound)

    return () => {
      document.removeEventListener('click', enableSound)
      document.removeEventListener('scroll', enableSound)
    }
  })

  const stopAllAudioRefs = () => {
    if (!!newRobotHereAudioRef.current && !newRobotHereAudioRef.current.paused && !newRobotHereAudioRef.current.ended) {
      newRobotHereAudioRef.current.loop = false;
      newRobotHereAudioRef.current.pause();
      newRobotHereAudioRef.current.currentTime = 0;
    }

    const audioElems = document.querySelectorAll(`audio.${NEW_ROBOT_HERE_AUDIO_ID}`);
    audioElems.forEach((elem) => {
      const audioElem = elem as HTMLAudioElement;
      if (audioElem && !audioElem.paused) {
        audioElem.pause();
        audioElem.currentTime = 0;
      }
      elem.remove();
    });

    newRobotHereAudioRef.current = null;
  }

  useEffect(() => {
    // When currentNotification is null, stop all audio
    if (!currentNotification) {
      stopAllAudioRefs();
      return
    }
  }, [currentNotification])

  useEffect(() => {
    if (!newRobotHereAudioRef.current) {
      return
    }
    const audioElems = document.querySelectorAll(`audio.${NOTIFICATION_AUDIO_ID}`);
    audioElems.forEach((elem, index) => {
      const audioElem = elem as HTMLAudioElement;
      if (audioElem && index > 0) {
        if (!audioElem.paused) {
          audioElem.pause();
          audioElem.currentTime = 0;
        }
        elem.remove();
      }
      // Only play the first audio element, stop the rest
    });
  }, [newRobotHereAudioRef.current])

  const getAudioSrc = () => {
    if (!currentNotification || !isNotificationOn) {
      return AUDIO_SOURCE.DEFAULT
    }

    const metaObj = JSON.parse(currentNotification.meta)
    const jobStatus = metaObj?.job_status || ''
    const swiftHereCondition = (currentNotification.type === 'recipient_notification' ? swiftHereRecipientStatuses : swiftHereSenderStatuses).includes(jobStatus)
    if (audioRef.current) {
      audioRef.current.loop = !!swiftHereCondition
    }
    if (swiftHereCondition) {
      return isSGH ? AUDIO_SOURCE.SWIFT_HERE : AUDIO_SOURCE.ROBOT_HERE;
    }
    return AUDIO_SOURCE.DEFAULT;
  }


  const { data: dataListRobot } = useRobots()
  const listRobot = dataListRobot?.data || [];


  const getRobotModel = (currentNotification: NotificationType) => {
    if (!currentNotification || listRobot.length === 0) {
      return DEFAULT_ROBOT_MODEL
    }

    const robotId = JSON.parse((currentNotification as unknown as { meta: string }).meta).robot_id;
    if (!robotId) {
      return DEFAULT_ROBOT_MODEL
    }
    const robotModel = listRobot.find((robot) => robot.robot_mac === robotId)?.robot_model || DEFAULT_ROBOT_MODEL;
    return robotModel;
  }

  const getRobotModelFromOrderNumber = async (currentNotif: NotificationType) => {
    const jobMeta = JSON.parse((currentNotif as unknown as { meta: string }).meta);
    if (!jobMeta) {
      return DEFAULT_ROBOT_MODEL;
    }
    const jobOrderNumber = jobMeta.order_number;
    if (!jobOrderNumber) {
      return DEFAULT_ROBOT_MODEL;
    }

    const jobLogs = await getJobLogs(jobOrderNumber);
    if (!jobLogs || jobLogs.length === 0) {
      return DEFAULT_ROBOT_MODEL;
    }

    const listLog = jobLogs.data;
    const robotId = listLog[0].robot_id;
    if (!robotId) {
      return DEFAULT_ROBOT_MODEL;
    }
    return listRobot.find((robot) => robot.robot_mac === robotId)?.robot_model || DEFAULT_ROBOT_MODEL;
  }

  const handleGetRobotImage = async (currentNotification: NotificationType) => {
    if (!currentNotification || listRobot.length === 0) {
      setImageUrl('');
      return;
    }

    if (currentNotification.type === CLEANING_NOTIFICATION_TYPE) {
      setImageUrl(getRobotImage(RobotModel.CC1))
      return
    }

    const notificationType = currentNotification.notification_details.notification_type;
    if (notificationType === 'fire') {
      const firstRobot = listRobot[0];
      setImageUrl(getRobotImage(firstRobot?.robot_model || DEFAULT_ROBOT_MODEL));
      return;
    }
    if (notificationType === 'robot_notification') {
      setImageUrl(getRobotImage(getRobotModel(currentNotification)));
      return;
    }
    if (notificationType === 'job_notification' || notificationType === 'recipient_notification' || notificationType === 'sender_notification') {
      const robotModel = await getRobotModelFromOrderNumber(currentNotification)
      setImageUrl(getRobotImage(robotModel));
      return;
    }
    if (notificationType ==='lift_notification') {
      // // console.log("lift notification, get robot model", currentNotification);
      setImageUrl(elevator);
      return
    }
    setImageUrl(getRobotImage(DEFAULT_ROBOT_MODEL));
  }

  useEffect(() => {
    if (!currentNotification) {
      setImageUrl('');
      return
    }
    handleGetRobotImage(currentNotification)
  }, [currentNotification])

  const pathname = location.pathname;
  const getStyle = (): CSSProperties => {

    // Only dashboard will have no scroll
    if (pathname === '/') {
      return {
        maxHeight: '100vh',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }
    }
    return {
      minHeight: '100vh',
      overflowX: 'hidden',
      overflowY: 'auto'
    }
  }

  return (
    <div style={getStyle()}>
      <TopBar toggleSidebar={toggleSidebar} handleNotificationDisplay={() => { }} notificationCount={0} handleIsOpen={toggleSidebar} />
      {/* <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} /> */}
      <main style={{ height: '100%', flex: 'auto' }}>{children}</main>

      {isNotificationOn && imageUrl ?
        <>
          <Notification imageUrl={imageUrl} onClose={closeNotification} onDismissAlarm={onDismissAlarm} />
          <audio
            id={NOTIFICATION_AUDIO_ID}
            className={NOTIFICATION_AUDIO_ID}
            ref={audioRef}
            loop={getAudioSrc() === AUDIO_SOURCE.SWIFT_HERE}
            src={getAudioSrc()}
            autoPlay
          />
        </>
        : null
      }
      {/* { isNotificationOn &&
        <NoncriticalNotification/>  
    } */}
    </div>
  );
};

export default MainLayout;
